import type { ReactNode } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import { BannerWrapper, IconWrapper, StyledBanner } from "./styles";

type WidgetBannerSchema = {
    title: string | ReactNode;
    dataAutomation?: string;
};

const WidgetBanner = ({ title, dataAutomation }: WidgetBannerSchema) => (
    <BannerWrapper data-automation={dataAutomation}>
        <StyledBanner
            title={<p className="benchmarkMetricBannerTitle">{title}</p>}
            CustomIcon={
                <IconWrapper>
                    <SWReactIcons
                        iconName="alerts"
                        size="xs"
                        iconColor={colorsPalettes.carbon[0]}
                    />
                </IconWrapper>
            }
        />
    </BannerWrapper>
);

export default WidgetBanner;
